import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { DialogHeader, DialogBody } from "@material-tailwind/react";
import { Select } from "@chakra-ui/react";
import { useAppDispatch, useAppSelector } from "../../../../utils/redux/hooks";
import { addservices } from "../../../../utils/redux/mainSlice";
import { addServices } from "../../../../utils/apis/func";
import { Dots } from "react-activity";
import axios from "axios";

export default function EditComp({ EditItem, categories, close }: any) {
  const dispatch = useAppDispatch();
  const services = useAppSelector((store) => store.user.services);
  const [name, setName] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [imageURL, setImageURL] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    setName(EditItem?.name || "");
    setCategoryId(EditItem?.categoryId?._id || EditItem?.categoryId || "");
    setImageURL(EditItem?.imageURL || null);
    setError("");
  }, [EditItem]);

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setIsLoading(true);
    setError("");
    try {
      const formData = new FormData();
      formData.append("profile-picture", file);
      formData.append("folder", "services");
      const response = await axios.post(process.env.REACT_APP_BASE_URL + "/upload", formData);
      if (!response.data?.url) throw new Error("Image upload failed.");
      setImageURL(response.data.url);
    } catch {
      setError("Image upload failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };
  const handleEdit = async () => {
    const id = EditItem?._id || EditItem?.id;
    if (!id || !name.trim()) {
      setError("A service name is required.");
      return;
    }
    setIsLoading(true);
    setError("");
    const changes = {
      name: name.trim(), value: name.trim(),
      ...(categoryId ? { categoryId } : {}),
      ...(imageURL && imageURL !== EditItem?.imageURL ? { imageURL } : {}),
    };
    try {
      const res: any = await addServices({ id, ...changes });
      if (res?.status !== 200 && res?.status !== 201) {
        throw new Error(res?.error?.message || "Could not save the service. Please try again.");
      }
      dispatch(addservices(services.map((service: any) =>
        (service._id || service.id) === id ? { ...service, ...changes } : service
      )));
      toast.success("Service updated successfully");
      close();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Could not save the service. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <DialogHeader>Edit Service</DialogHeader>
      <DialogBody>
        <form onSubmit={(event) => { event.preventDefault(); void handleEdit(); }}>
          <fieldset disabled={isLoading} className="flex flex-col gap-5 px-3 lg:px-6">
            {EditItem?.disabled && <p className="text-red-900">This service has been disabled.</p>}
            <div>
              <label htmlFor="service-name" className="mb-2 block text-sm font-medium">Name</label>
              <input id="service-name" name="name" required value={name}
                onChange={(event) => setName(event.target.value)}
                className="block w-full rounded-lg border border-gray-300 p-2.5 text-gray-900" />
            </div>
            <div>
              <label htmlFor="service-category" className="mb-2 block text-sm font-medium">Category</label>
              <Select id="service-category" value={categoryId}
                onChange={(event) => setCategoryId(event.target.value)}>
                <option value="" disabled>Select service category</option>
                {categories?.map((category: any) => (
                  <option key={category._id || category.id} value={category._id || category.id}>{category.name}</option>
                ))}
              </Select>
            </div>
            <div>
              <label htmlFor="service-image" className="mb-2 block text-sm font-medium">Service image</label>
              <input type="file" id="service-image" accept="image/*" onChange={handleFileChange} />
            </div>
            {imageURL && <img src={imageURL} alt="Service" width="100" />}
            {error && <p role="alert" className="text-red-700">{error}</p>}
            <button type="submit" disabled={isLoading}
              className="rounded-md bg-[#88087B] px-6 py-3 text-[#FFCD1E] disabled:opacity-60">
              {isLoading ? <Dots size={20} color="#FFCD1E" /> : "Save Changes"}
            </button>
          </fieldset>
        </form>
      </DialogBody>
    </>
  );
}
